const DEFAULT_TYPES = ["Documents", "DesignChanges", "Drawings"];

function allowedTypes(detected) {
	if (Array.isArray(detected?.entityTypes) && detected.entityTypes.length) return detected.entityTypes;
	return detected?.entityType ? [detected.entityType] : [];
}

function matchesSuggestion(detected, hit) {
	const fragment = String(detected?.number || "").trim();
	if (!fragment || !hit?.entityId || !hit.type || !hit.number) return false;
	if (!allowedTypes(detected).includes(hit.type)) return false;
	return String(hit.number).toUpperCase().includes(fragment.toUpperCase());
}

/**
 * Reuse EntityText's number-fragment lookup. A detected caret match retains its
 * type restrictions; a plain query searches the resolver's existing default types.
 * `resolve` is the tenant's resolveDatabaseItems callable.
 */
async function searchDatabaseItems(query, { resolve, databaseURL }) {
	const detected = typeof query === "string"
		? { number: query, entityTypes: DEFAULT_TYPES }
		: query;
	if (!String(detected?.number || "").trim()) return [];

	const result = await resolve({
		numbers: [detected.number],
		types: allowedTypes(detected),
		databaseURL,
	});
	if (!Array.isArray(result.data?.matches)) {
		throw new Error("Invalid database search response.");
	}
	const unique = new Map();
	for (const hit of result.data.matches) {
		if (matchesSuggestion(detected, hit)) {
			unique.set(`${hit.type}:${hit.entityId}`, {
				...hit,
				id: hit.entityId,
				label: hit.title || "",
				route: `/Database/${hit.type}/${encodeURIComponent(hit.entityId)}`,
			});
		}
	}
	return [...unique.values()];
}

export { matchesSuggestion, searchDatabaseItems };
